import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, Box } from '@material-ui/core';
import classNames from 'classnames';
import { keyEmptyCheck } from 'aurora-utils/utils';
import PropTypes from 'prop-types';
import { ADGMAlert } from 'aurora-components';
import { DocumentsV2 } from 'aurora-section-components';

import styles from './styles';

/**
 * Reusable Alert Box Componnent.
 *
 * @param {boolean} isReject - Boolean value to check if the application is rejected or returned.
 * @param {Array} reasons - An array of strings
 * @param {Object} classes - The CSS classes injected by withStyles.
 */

function RejectReturnAlertBox({
  isReject,
  reasons,
  classes,
  alertTitle,
  editHandler,
  locale,
  documents,
  application,
  handleDownloadDocument,
  REJECTTION_DOCUMENTS_TO_RENDER,
}) {
  return (
    <>
      <ADGMAlert type={isReject ? 'error' : 'warning'} customClasses={{ container: classes.alert }}>
        <Typography className={classes.alertText}>
          {keyEmptyCheck(
            alertTitle || isReject ? 'the_application_has_been_rejected' : 'the_application_has_been_returned',
          )}
        </Typography>
        {typeof editHandler === 'function' && (
          <Button className={classes.alertEditBtn} onClick={editHandler}>
            {keyEmptyCheck('edit_application')}
          </Button>
        )}
      </ADGMAlert>
      {reasons?.length > 0 && (
        <div className={classNames(classes.ReturnRejectBox, isReject ? classes.RedBox : classes.YellowBox)}>
          <Typography variant='subtitle1'>
            {keyEmptyCheck(isReject ? 'feedback_for_reject' : 'feedback_note_for_return')}
          </Typography>
          <Typography variant='body1'>
            {reasons?.map(reason => (
              <Typography key={reason}>{reason}</Typography>
            ))}
          </Typography>
          {documents?.length > 0 && (
            <Box mt={2}>
              <DocumentsV2
                showTitle={false}
                handleUploadDoc={null}
                isEditable={false}
                handleDeleteDoc={null}
                handleDocDownload={handleDownloadDocument}
                hideDownloadAllBtn
                isPanel={false}
                {...{
                  locale,
                  applicationId: application?.applicationDetails?.applicationId,
                  applicationType: application?.applicationDetails?.applicationType,
                  documents,
                  application,
                  attributes: REJECTTION_DOCUMENTS_TO_RENDER,
                }}
              />
            </Box>
          )}
        </div>
      )}
    </>
  );
}

RejectReturnAlertBox.propTypes = {
  classes: PropTypes.object.isRequired,
  reasons: PropTypes.array.isRequired,
  isReject: PropTypes.bool.isRequired,
  alertTitle: PropTypes.string,
  editHandler: PropTypes.any,
  locale: PropTypes.string,
  application: PropTypes.object,
  documents: PropTypes.array,
  handleDownloadDocument: PropTypes.func,
  REJECTTION_DOCUMENTS_TO_RENDER: PropTypes.array,
};

RejectReturnAlertBox.defaultProps = {
  alertTitle: '',
  application: {},
  editHandler: null,
  locale: '',
  documents: [],
  handleDownloadDocument: null,
  REJECTTION_DOCUMENTS_TO_RENDER: [],
};

export default withStyles(styles)(RejectReturnAlertBox);
